import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IUser } from "models/Login/login.model";
import { ILoginState } from "models/Slices/loginSlice.model";
import { loginAsync } from "redux/actions/Login.action";

const initialState: ILoginState = {
  user: null,
  phoneNumber: "",
  token: null,
  loading: false,
  isLoggedIn: false,
  error: "",
  success: false,
  isUserNameRequired: false,
  temp: {
    mbb: "",
    igsEnc: "",
    TokenSessionId: "",
    UserId: "",
  },
  clientUID: "",
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    PhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    ResetLoginError: (state) => {
      state.error = "";
    },
    ResetLogin: (state) => initialState,
    tempLogin: (state, action: PayloadAction<object>) => {
      state.temp = action.payload;
    },
    setFirstPassUserName: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    setClientUID: (state, action: PayloadAction<string>) => {
      state.clientUID = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginAsync.fulfilled, (state, action: PayloadAction<IUser>) => {
        state.loading = false;
        state.user = action.payload;
        state.success =
          state.user?.DialogBoxes.length === 0 && !state.user?.IsIgsLocked
            ? true
            : false;
        state.isLoggedIn = state.success;
        state.isUserNameRequired = action.payload.isUserNameRequired;
      })
      .addCase(loginAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.user = null;
        state.isLoggedIn = false;
        state.success = false;
      });
  },
});

export const {
  PhoneNumber,
  ResetLoginError,
  ResetLogin,
  tempLogin,
  setFirstPassUserName,
  setClientUID,
} = loginSlice.actions;

export const selectUser = (state: RootState) => state.login.user;
export const selectIsLoggedIn = (state: RootState) => state.login.isLoggedIn;
export const selectPhoneNumber = (state: RootState) => state.login.phoneNumber;
export const selectTempLogin = (state: RootState) => state.login.temp;

export default loginSlice.reducer;
